import { LanguageType } from '@nx-smartmonkey/shared/domain';

import CaFlag from '../../../assets/img/admin-translations/ca_flag.svg';
import CsFlag from '../../../assets/img/admin-translations/cs_flag.svg';
import DeFlag from '../../../assets/img/admin-translations/de_flag.svg';
import EnFlag from '../../../assets/img/admin-translations/en_flag.svg';
import EsFlag from '../../../assets/img/admin-translations/es_flag.svg';
import FiFlag from '../../../assets/img/admin-translations/fi_flag.svg';
import FrFlag from '../../../assets/img/admin-translations/fr_flag.svg';
import HuFlag from '../../../assets/img/admin-translations/hu_flag.svg';
import ItFlag from '../../../assets/img/admin-translations/it_flag.svg';
import PtFlag from '../../../assets/img/admin-translations/pt_flag.svg';
import RoFlag from '../../../assets/img/admin-translations/ro_flag.svg';
import RuFlag from '../../../assets/img/admin-translations/ru_flag.svg';

const langImages: Record<LanguageType, string> = {
  ca: CaFlag,
  en: EnFlag,
  es: EsFlag,
  pt: PtFlag,
  de: DeFlag,
  hu: HuFlag,
  ro: RoFlag,
  fr: FrFlag,
  ru: RuFlag,
  fi: FiFlag,
  it: ItFlag,
  cs: CsFlag,
};

export const getFlagByLocale = (language: LanguageType) => {
  return langImages[language];
};
